import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import api from '@/lib/api';

const KEYS = [
  ['street', 'Street name'], ['building_number', 'Building no. (4 digits)'], ['district', 'District'],
  ['city', 'City'], ['postal_code', 'Postal code (5 digits)'],
  ['additional_number', 'Secondary / additional no. (4 digits)'], ['short_address', 'Short address (e.g. RHFA 2667)'],
];

// Structured ZATCA seller address on the existing Company Profile; can pre-fill from the free-text address.
export const ZatcaAddressFields = ({ data, set }) => {
  const [sugg, setSugg] = useState({});
  useEffect(() => {
    api.get('/zatca-p2/seller-readiness').then((r) => setSugg(r.data.address_suggestions || {})).catch(() => {});
  }, []);
  const canFill = KEYS.some(([k]) => !data[`zatca_${k}`] && sugg[k]);
  return (
    <div className="space-y-2 sm:col-span-2 rounded-lg border border-border p-3" data-testid="cp-zatca-address">
      <div className="flex items-center justify-between">
        <Label>ZATCA seller address (structured, used on e-invoices)</Label>
        {canFill && (
          <Button type="button" size="sm" variant="outline" data-testid="cp-zatca-fill-btn"
            onClick={() => KEYS.forEach(([k]) => { if (!data[`zatca_${k}`] && sugg[k]) set(`zatca_${k}`, sugg[k]); })}>
            Fill from address above
          </Button>
        )}
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {KEYS.map(([k, label]) => (
          <div key={k}>
            <Label className="text-xs">{label}</Label>
            <Input value={data[`zatca_${k}`] || ''} onChange={(e) => set(`zatca_${k}`, e.target.value)}
              placeholder={sugg[k] || ''} data-testid={`cp-zatca-${k}`} />
          </div>
        ))}
      </div>
    </div>
  );
};
